// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./+not-found.tsx": { enumerable: true, get() { return require("/opt/actions-runner/_work/sg-monorepo/sg-monorepo/apps/order/src/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/opt/actions-runner/_work/sg-monorepo/sg-monorepo/apps/order/src/app/_layout.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/opt/actions-runner/_work/sg-monorepo/sg-monorepo/apps/order/src/app/index.tsx"); } },
  "./loyalty/index.tsx": { enumerable: true, get() { return require("/opt/actions-runner/_work/sg-monorepo/sg-monorepo/apps/order/src/app/loyalty/index.tsx"); } },
  "./menu/index.tsx": { enumerable: true, get() { return require("/opt/actions-runner/_work/sg-monorepo/sg-monorepo/apps/order/src/app/menu/index.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;